"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AleaRandomGenerator_1 = __importDefault(require("./AleaRandomGenerator"));
const createAleaGenerator_1 = __importDefault(require("./createAleaGenerator"));
/**
 * @typedef {import ('./AbstractRandomGenerator').default} AbstractRandomGenerator
 */
/**
 * @typedef {object} RandomGeneratorProperties
 * @property {(...seeds: string[]) => AleaRandomGenerator} createWithSeeds
 * @property {AleaRandomGenerator} insecure
 */
/**
 * @param  {import ('./AbstractRandomGenerator').default} baseGenerator
 * @returns {AbstractRandomGenerator & RandomGeneratorProperties}
 */
function createRandom(baseGenerator) {
    const generator = Object.create(baseGenerator);
    // Create a non-cryptographically secure PRNG with a given seed (using
    // the Alea algorithm)
    /**
     * @param  {string[]} seeds
     * @returns {Object}
     */
    generator.createWithSeeds = (...seeds) => {
        if (seeds.length === 0) {
            throw new Error('No seeds were provided');
        }
        return new AleaRandomGenerator_1.default({ seeds });
    };
    // Used like `Random`, but much faster and not cryptographically
    // secure
    generator.insecure = (0, createAleaGenerator_1.default)();
    return generator;
}
exports.default = createRandom;
//# sourceMappingURL=createRandom.js.map